import { Content } from 'src/contexts/ContentContext';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { ContentId } from 'src/utils/constants/contentId';
import { Permission } from 'src/WebApiController';

import * as styles from './ProceedsCell.css';

export type ProceedsCellProps = {
  displayValue?: string;
  margin?: number;
};

export const ProceedsCell = ({ displayValue, margin }: ProceedsCellProps) => {
  const hasTotalNetProceedsPermissions = useUserHasAnyOfPermissions(
    Permission.Sales_ViewProceeds,
    Permission.Sales_ViewRecentProceeds
  );

  return (
    <div className={styles.proceedsWrapper}>
      <span className={styles.proceeds}>
        {!displayValue ? (
          hasTotalNetProceedsPermissions ? (
            <Content id={ContentId.NA} />
          ) : null
        ) : (
          displayValue
        )}
      </span>
      {margin && (
        <span className={styles.proceedsMargin}>{margin.toFixed(2)}%</span>
      )}
    </div>
  );
};
